import React from 'react';
import { useDocumentTitle } from '~/hooks';
import { Header, Page } from '../components';
import AdministratorsList from './AdministratorsList';

export default function Administrators() {
  useDocumentTitle('Administrators - Admin');

  return (
    <Page>
      <Header />
      <AdministratorsList />
    </Page>
  );
}
